import {
  createFailAction,
  createStartAction,
  createSuccessAction,
} from 'app/api/redux-util/async-helpers';
import { callApiByName } from 'app/api/redux-feeny/proxy';

let feenyInitPromise = null;

// For tests
export function resetInit() {
  feenyInitPromise = null;
}

const feenyMiddleware = store => next => action => {
  if (!action.feeny) {
    // Normal action: pass it on
    return next(action);
  }

  const apiCall = action.feeny.apiCall;
  const args = action.feeny.args;
  if (apiCall) {
    if (window.feenyLoadError) {
      store.dispatch(createStartAction(apiCall, args));
      store.dispatch(createFailAction(apiCall, {}, args));
      return Promise.resolve();
    }

    if (!feenyInitPromise) {
      feenyInitPromise = window.Feeny.init();
    }

    store.dispatch(createStartAction(apiCall, args));
    return feenyInitPromise
      .then(() => callApiByName(apiCall, args))
      .then(response =>
        store.dispatch(createSuccessAction(apiCall, response, args))
      )
      .catch(e => store.dispatch(createFailAction(apiCall, e, args)));
  }

  return Promise.resolve();
};

export default feenyMiddleware;
